var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"event",on:{"click":_vm.open}},[(_vm.loading)?_c('div',{staticClass:"icon"},[_c('uiLoader')],1):_c('div',{staticClass:"icon"},[_vm._v(_vm._s(_vm.icon))]),_c('div',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.title)+" "),_c('span',[_vm._v(_vm._s(_vm.text))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }